export default __webpack_public_path__ + "static/media/sara.eea0cfed.png";